import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
//import { useMsal } from "@azure/msal-react";
import React, { useContext, useState, useEffect } from "react";
import OperateurEcoIcon from "../../../asset/images/OperateurEcoIcon.png";
import SecteurAIcon from "../../../asset/images/SecteurAIcon.png";
import worldIcon from "../../../asset/images/worldIcon.png";
import { getReferentielDataFromServer } from "../../../common/components/general/AxiosReferencielInterceptor";
import { AuthContext } from "../../../common/components/general/TSAuthProvider";
import AppSelectInputApi from "../../../common/components/ui/AppSelectInputApi";
import TSGrid from "../../../common/components/ui/TSGrid";
import { DEFAULT_ERROR_MESSAGE, FIELD_OBLIGATOIRE } from "../../../common/constants/generalConstants";
import { useAlert } from "../../../common/hooks/useAlert";
import JwtUtils from "../../../common/router/JwtUtils";

const UserInfoDialog = ({ open, onClose }) => {
  const { showAlert } = useAlert();
  const { logout } = useContext(AuthContext);
  const [payId, setPayId] = useState(null);
  const [regionId, setRegionId] = useState(null);
  const [sectorId, setSectorId] = useState(null);
  const [typeOperatorId, setTypeOperatorId] = useState(null);
  const [selectedPay, setSelectedPay] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedSector, setSelectedSector] = useState(null);
  const [selectedOperator, setSelectedOperator] = useState(null);
  const [payError, setPayError] = useState(null);
  const [regionError, setRegionError] = useState(null);
  const [sectorError, setSectorError] = useState(null);
  const [typeOperatorError, setTypeOperatorError] = useState(null);
  const [profileData, setProfileData] = useState(null);

  useEffect(() => {
    if (open) {
      getReferentielDataFromServer(false, "api/user/profile", {}, "get")
        .then((res) => {
          if (!res?.error && res) {
            setProfileData(res);
          }
        })
        .catch((error) => {
          console.error("Error fetching user profile:", error);
        });
    }
  }, [open]);

  const validateForm = () => {
    const isMaroc = selectedPay?.label === "Maroc";
    const hasErrors = !payId || !sectorId || !typeOperatorId || (isMaroc && !regionId);
    
    if (hasErrors) {
      if (!payId) setPayError(FIELD_OBLIGATOIRE);
      if (isMaroc && !regionId) setRegionError(FIELD_OBLIGATOIRE);
      if (!sectorId) setSectorError(FIELD_OBLIGATOIRE);
      if (!typeOperatorId) setTypeOperatorError(FIELD_OBLIGATOIRE);
      return true;
    }
    
    setPayError(null);
    setRegionError(null);
    setSectorError(null);
    setTypeOperatorError(null);
    return false;
  };
  const submitInfo = () => {
    if (!!validateForm()) {
      return;
    }
    getReferentielDataFromServer(
      false,
      "api/user/update-info",
      {
        payId,
        sectorId,
        typeOperatorId,
        uuid: JwtUtils.getUUID(),
        ...(selectedPay?.label === "Maroc" && { regionId }),
      },
      "post"
    ).then((res) => {
      if (!res?.error) {
        onClose();
        showAlert("success", res || "Vos données ont été enregistrées avec succès. Merci pour votre contribution !");
        return;
      }
      if (res?.status === 403) {
        logout();
        window.location.reload();
        return;
      }
      showAlert("error", res.message ?? DEFAULT_ERROR_MESSAGE);
      console.error(res);
    });
  };
  return (
    <Dialog
      open={open}
      onClose={null}
      disableEscapeKeyDown
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "30px",
          maxWidth: "550px",
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">
        <TSGrid item xs={12}>
          <TSGrid container>
            <TSGrid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                variant="tsh4"
                sx={{
                  fontSize: "30px",
                  lineHeight: "45px",
                  color: "#1B738A",
                }}
              >
                Complétez votre profil
              </Typography>
            </TSGrid>
            <TSGrid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                variant="tsb1"
                sx={{
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  WebkitLineClamp: 2,
                  textOverflow: "ellipsis",
                }}
              >
                {`En complétant votre profil vous assurerez des réponses /n adaptées et personnalisées.`
                  .split("/n")
                  .map((item, index) => (
                    <>
                      {item}
                      {index < 1 && <br />}
                    </>
                  ))}
              </Typography>
            </TSGrid>
          </TSGrid>
        </TSGrid>
      </DialogTitle>
      <DialogContent
        sx={{ padding: "0px", overflowX: "hidden", paddingBottom: "40px" }}
      >
        <TSGrid container spacing={2} mt={"1px"}>
          <TSGrid
            item
            xs={12}
            sx={{
              paddingTop: "10px",
              paddingBottom: "10px",
              PaddingLeft: "10px",
              PaddingRight: "10px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <TSGrid container sx={{ ml: "6%" }} spacing={3}>
              <TSGrid item xs={10}>
                <AppSelectInputApi
                  name="payId"
                  label="Pays"
                  value={selectedPay}
                  onChange={(e) => {
                    setPayId(e?.id);
                    setSelectedPay(e);
                    // Reset region when changing country
                    if (e?.label !== "Maroc") {
                      setRegionId(null);
                      setSelectedRegion(null);
                    }
                    setRegionError(null);
                  }}
                  apiOptions={{
                    api: "api/referential/pays",
                  }}
                  startAdornment={
                    <img
                      src={worldIcon}
                      alt="world"
                      style={{
                        width: "20px",
                        height: "20px",
                        paddingRight: "5px",
                      }}
                    />
                  }
                  error={payError}
                  initialValueId={profileData?.pays?.id}
                />
              </TSGrid>
              
              {/* Region field - only show when Morocco is selected */}
              {selectedPay?.label === "Maroc" && (
                <TSGrid item xs={10}>
                  <AppSelectInputApi
                    name="regionId"
                    label="Région"
                    value={selectedRegion}
                    onChange={(e) => {
                      setRegionId(e?.id);
                      setSelectedRegion(e);
                      setRegionError(null);
                    }}
                    apiOptions={{
                      api: `api/referential/region?v0=${payId}`,
                    }}
                    startAdornment={
                      <img
                        src={worldIcon}
                        alt="region"
                        style={{
                          width: "20px",
                          height: "20px",
                          paddingRight: "5px",
                        }}
                      />
                    }
                    error={regionError}
                    initialValueId={profileData?.region?.id}
                  />
                </TSGrid>
              )}
              
              <TSGrid item xs={10}>
                <AppSelectInputApi
                  name="sectorId"
                  label="Secteur d'activité"
                  value={selectedSector}
                  onChange={(e) => {
                    setSectorId(e?.id);
                    setSelectedSector(e);
                  }}
                  apiOptions={{
                    api: "api/referential/secteur-activite",
                  }}
                  startAdornment={
                    <img
                      src={SecteurAIcon}
                      alt="world"
                      style={{
                        width: "20px",
                        height: "20px",
                        paddingRight: "5px",
                      }}
                    />
                  }
                  error={sectorError}
                  initialValueId={profileData?.secteurActivite?.id}
                />
              </TSGrid>
              <TSGrid item xs={10}>
                <AppSelectInputApi
                  name="typeOperatorId"
                  label="Type d'opérateur économique"
                  value={selectedOperator}
                  onChange={(e) => {
                    setTypeOperatorId(e?.id);
                    setSelectedOperator(e);
                  }}
                  apiOptions={{
                    api: "api/referential/type-operateur",
                  }}
                  startAdornment={
                    <img
                      src={OperateurEcoIcon}
                      alt="world"
                      style={{
                        width: "20px",
                        height: "20px",
                        paddingRight: "5px",
                      }}
                    />
                  }
                  error={typeOperatorError}
                  initialValueId={profileData?.typeOperateur?.id}
                />
              </TSGrid>
            </TSGrid>
          </TSGrid>
          <TSGrid item xs={12} sx={{ textAlign: "center" }}>
            <Button
              variant="contained"
              sx={{
                background:
                  "linear-gradient(274.25deg, #2DC5EE -48.01%, #15C087 140.23%)",
                color: "#fff",
                padding: "5px 40px",
                borderRadius: "9px",
                textTransform: "none",
                "&:hover": {
                  background:
                    "linear-gradient(90deg, rgb(84, 131, 86) 0%, rgb(17, 111, 118) 100%)",
                },
              }}
              onClick={() => submitInfo()}
            >
              Continuer
            </Button>
          </TSGrid>
        </TSGrid>
      </DialogContent>
    </Dialog>
  );
};

export default UserInfoDialog;
